// Every sidebar listing page's URL, in one place. A sidebar parent is a URL section; its
// pages live under it. `tabs` maps each tab id to its slug: the "" tab is served at `path`,
// every other tab one segment below (/incidents/ and /incidents/assigned). A section root
// with `redirectTo` has no page of its own -- it may also carry `tabs`, all of them slugged
// (no ""), redirecting to one of those tabs' own paths (e.g. organization -> /organization/tenants).
// Paths only -- pages import this file, so it must not import them. Content.js pairs each
// route with its component.
export const ROUTES = {
    root: { path: "/", redirectTo: "/drivers/" },

    onboarding: { path: "/onboarding/", redirectTo: "/onboarding/leads" },
    leads: { path: "/onboarding/leads", tabs: { open: "", review: "review", didnttakecar: "didnt-take-car", dnr: "dnr", all: "all", reports: "reports" } },
    applications: { path: "/onboarding/applications", tabs: { applications: "" } },
    insurances: { path: "/onboarding/insurances", tabs: { commercial: "", uw: "pending-uw", active: "active", all: "all", reports: "reports" } },
    reservations: { path: "/onboarding/reservations", tabs: { open: "", awaiting: "awaiting", all: "all", reports: "reports" } },

    drivers: { path: "/drivers/", tabs: { active: "", all: "all" } },
    driversFollowUp: { path: "/drivers/follow-up" },
    driversInteractions: { path: "/drivers/interactions" },
    argyle: { path: "/drivers/argyle", tabs: { connected: "", neverconnected: "never-connected", activedriverargyleaccounts: "active-drivers" } },

    billing: { path: "/billing/", redirectTo: "/billing/collections" },
    collections: { path: "/billing/collections", tabs: { collection: "", disabled_repo: "disabled-repo", baddebt: "bad-debt", baddebt_batches: "bad-debt-batches" } },
    collectionsSpine: { path: "/billing/collections/spine" },
    scheduledPayments: { path: "/billing/scheduled-payments", tabs: { all: "", reports: "reports" } },
    paymentPlans: { path: "/billing/payment-plans", tabs: { all: "", reports: "reports" } },
    subscriptions: { path: "/billing/subscriptions", tabs: { all: "", reports: "reports" } },

    fleet: { path: "/cars/" },
    availableCars: { path: "/cars/available", tabs: { avaialble: "", scheduled: "scheduled" } },
    pricing: { path: "/cars/pricing", tabs: { pricing: "", promotions: "promotions", reports: "reports" } },
    maintenance: { path: "/cars/maintenance", tabs: { issues: "", jobs: "jobs", work_order: "work-orders", reports: "reports" } },
    carInspections: { path: "/cars/inspections" },
    registrations: { path: "/cars/registrations" },
    dmvInspections: { path: "/cars/dmv-inspections" },

    rentals: { path: "/rentals/", tabs: { all: "", reports: "reports" } },
    carReturns: { path: "/rentals/returns", tabs: { awaitingToCloseout: "", incompleteReturns: "incomplete", lost: "lost", all: "all", reports: "reports" } },

    incidents: {
        path: "/incidents/",
        redirectTo: "/incidents/assigned",
        tabs: { all: "all", assigned: "assigned", notassingend: "unassigned", reports: "reports" },
    },
    claims: { path: "/incidents/claims", tabs: { liability: "", subro: "subro", reports: "reports" } },
    tpa: { path: "/incidents/tpa", tabs: { tpa: "", configuration: "configuration", adjusters: "adjusters" } },

    // More: each page is a section of its own
    organization: {
        path: "/organization/",
        redirectTo: "/organization/tenants",
        tabs: {
            tenants: "tenants", branches: "branches", members: "members", permissions: "permissions",
            groups: "groups", billing_management: "billing-management", object_permissions: "object-permissions",
        },
    },
    attributes: { path: "/attributes/" },
    automations: { path: "/automations/", tabs: { automations: "", "execution-logs": "execution-logs" } },
}

// The react-router path for a route: tabbed routes take a tab segment, optional unless the
// route is a section root (`redirectTo`) with no page of its own -- there the bare path is
// reserved for the redirect, so the tab segment is required.
export const routePattern = (route) => route.tabs
    ? `/${route.path.replace(/^\/+|\/+$/g, "")}/:tab${route.redirectTo ? "" : "?"}`
    : route.path
